import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { dashboard as DashboardApi } from "@teem/constants/api";
import { environment } from '@teem/environments/environment';
import { LoaderService } from '@teem/services/loader.service';
import { ClientService } from '@teem/services/client.service';
import { country as CountryApi } from '@teem/constants/api';
import { ClientForm } from '@teem/model-forms/client-form';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import { Client } from '@teem/models/client';
import { InvoiceService } from '@teem/app/core/services/invoice.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';

@Component({
	selector: 'edit-client',
	templateUrl: './edit-client.component.html',
	styles: []
})

export class EditClientComponent implements OnInit, AfterViewInit {
	@Input() clientDetail: any;
	@Input() activeTab: any = 'edit-client';
	@Output() onSubmit: EventEmitter<any> = new EventEmitter();
	@Output() onDelete: EventEmitter<any> = new EventEmitter();
	@Output() orderAction: EventEmitter<any> = new EventEmitter();
	@Output() changeTab: EventEmitter<any> = new EventEmitter();
	editNameForm: FormGroup;
	clientForm: FormGroup;
	editNameMode: boolean = false;
	getAcronym = getAcronym;
	nameSubmitted: boolean = false;
	submitted: boolean = false;
	totalEarnings: number = 0;
	activeProjectsCount: number = 0;
	completedProjectsCount: number = 0;
	projects: Array<any> = [];
	loadingProjects: boolean = false;
	countryListApi: string = CountryApi.endPoint;
	selectedCountry: any;
	from_date: Date = null;
	to_date: Date = null;

	itemsPerPageOptions = [10, 20, 50, 100];

	// projectPaginator: any = {
	// 	currentPage: 2,
	// 	isLast: false,
	// 	getPage: this.getProjects.bind(this),
	// 	next: function () {
	// 		if (this.hasNext())
	// 			this.getPage(this.currentPage + 1);
	// 	},
	// 	previous: function () {
	// 		if (this.hasPrevious())
	// 			this.getPage(this.currentPage - 1)
	// 	},
	// 	hasPrevious: function () {
	// 		return this.currentPage > 1;
	// 	},
	// 	hasNext: function () {
	// 		return !this.isLast;
	// 	}
	// }

	currentPage = 1;
	pageSize = environment.pageSize;
	itemsPerPage = environment.pageSize;
	totalItems = 0; // example
	maxPagesToShow = 3;

	projectPaginator: any = {
		id: 'table-paginator',
		currentPage: 1,
		itemsPerPage: environment.pageSize,
		totalItems: 0
	}

	constructor(
		private fb: FormBuilder,
		private loaderService: LoaderService,
		private clientService: ClientService,
		private invoiceService: InvoiceService,
		private renderer: Renderer2,
		private router: Router) { }

	ngOnInit(): void {
		if (!this.clientDetail.projects)
			this.clientDetail.projects = [];

		this.clientForm = this.fb.group(new ClientForm(new Client(this.clientDetail)));

		this.editNameForm = this.fb.group({
			first_name: this.fb.control(this.clientDetail.first_name, [Validators.required, Validators.maxLength(99), Validators.minLength(2)]),
			last_name: this.fb.control(this.clientDetail.last_name, [Validators.maxLength(99), Validators.minLength(2)]),
		});

		this.activeProjectsCount = this.clientDetail.active_project;
		this.completedProjectsCount = this.clientDetail.completed_project;
		this.totalEarnings = this.clientDetail.paid_amount;

		if (this.clientDetail.country_id) {
			this.selectedCountry = {
				id: this.clientDetail.country_id,
				country_name: this.clientDetail.country_name
			}
		}


		this.getProjects();
	}

	ngAfterViewInit(): void {
		this.initNiceSelect();

	}

	// Toggle visibility of the options menu
	toggleOptionsMenu(projectId: number) {
		this.projects.forEach(project => {
			if (project.invoice_number !== projectId) {
				project.showOptions = false;
			}
		});

		const project = this.projects.find(p => p.invoice_number === projectId);
		if (project) {
			project.showOptions = !project.showOptions;
		}
	}

	// Component method to determine the appropriate class based on the project status
	getOrderStatusClass(project: any): string {
		let colorClass = "order_unpaid";  // default class for unpaid status

		if (project.is_draft) {
          colorClass = 'order_complete';
          status = i18n.draft;
        } else {
          if (project.status == 'paid') {
            colorClass = 'order_new';
          } else if (project.status == 'partially') {
            colorClass = 'order_preparing';
          } else if (project.status == 'pending') {
            colorClass = 'order_preparing';
          } else if (project.status == 'refund') {
            colorClass = 'order_new';
          } else if (project.status == 'pending_confirmation') {
            colorClass = 'order_preparing';
          } else if (project.status == 'draft') {
            colorClass = 'order_complete';
          }
        }
		

		// if (project.is_draft) {
		// 	colorClass = 'order_complete';  // when project is in draft
		// } else {
		// 	if (project.due_amount == 0) {
		// 		colorClass = 'order_complete';  // completed status (due_amount == 0)
		// 	} else if (project.due_amount > 0) {
		// 		colorClass = 'order_in_progress';  // in progress (due_amount > 0)
		// 	}
		// }
		return colorClass;
	}

	// Component method to determine the appropriate circle color
	getCircleColor(project: any): string {
		return project.due_amount == 0 ? '#18F121' : '#C4C4C4';  // green for completed, grey for in-progress
	}

	// Component method to determine the status text
	getOrderStatusText(project: any): string {
		return i18n[project.status] ? i18n[project.status] : i18n.pending;
		return project.due_amount == 0 ? 'Completed' : 'In Progress';  // text based on due_amount
	}

	onDateChange(event: any, dateType: 'from' | 'to'): void {
		if (dateType === 'from') {
			this.from_date = event.target.value;
			console.log('From date changed:', this.from_date);
		} else if (dateType === 'to') {
			this.to_date = event.target.value;
			console.log('To date changed:', this.to_date);
		}

		this.getProjects(1, true);
	}

	onChangeItemsPerPage(event: Event) {
		const selectElement = event.target as HTMLSelectElement;
		this.itemsPerPage = +selectElement.value;
		this.getProjects(1);
		this.initNiceSelect();
	}

	initNiceSelect() {

		console.log('this is inside123.')
		setTimeout(() => {
			const $select = $('#tab-links-select-invoice[nice-select]');
			// $select.niceSelect?.('destroy');  // clean up
			// $select.niceSelect();             // re-init
		}, 5);
	}

	getProjects(page: number = 1, filter = false) {
		this.loadingProjects = true;

		this.clientService.invoices(this.clientDetail.uuid, {
			page: page,
			limit: this.itemsPerPage,
			paginate_type: 'simple',
			from_date: this.from_date,
			to_date: this.to_date
		}).subscribe((data: any) => {

			if (data.meta) {
				this.totalItems = data.meta.total;
				this.currentPage = data.meta.current_page;
				this.itemsPerPage = parseInt(data.meta.per_page, 10);

				this.projectPaginator.totalItems = data.meta.total;
				this.projectPaginator.currentPage = data.meta.current_page;
				this.projectPaginator.from = data.meta.from;
				this.projectPaginator.to = data.meta.to;
				this.projectPaginator.itemsPerPage = parseInt(data.meta.per_page, 10);
				// this.data = r.data;

				// console.log(this.data);
				console.log('this.projectPaginator');
				console.log(this.projectPaginator);
			}

			// if(!filter) {
			// 	if (data.data) {
			// 		data.data.forEach((item, index) => {
			// 			this.projects.push(item);
			// 		});
			// 	}
			// } else {
			this.projects = data.data;
			this.initNiceSelect();
			// }

			// if (data.meta) {
			// 	this.projectPaginator.totalItems = data.meta.total;
			// 	this.projectPaginator.currentPage = data.meta.current_page;
			// }
			// this.projectPaginator.isLast = (data.links.next == null) ? true : false;

			this.loadingProjects = false;
		}, err => {
			this.loadingProjects = false;

			Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
		})
	}

	onCountryChange(value: any) {
		if (value.calling_code) {
			this.clientForm.get('dial_code').setValue('+' + value.calling_code);
		}
	}

	sendInvoice() {
		this.router.navigate(['/invoices'], { queryParams: { 'create-invoice': true, 'client': this.clientDetail.uuid } });
	}

	onEditName() {
		this.editNameMode = true;
	}

	onSubmitClientName() {
		this.nameSubmitted = true;
		if (this.editNameForm.valid) {
			this.loaderService.startLoading();
			this.clientService.updateName(this.clientDetail.uuid, this.editNameForm.value).subscribe(data => {
				this.loaderService.stopLoading();
				let fd = this.editNameForm.value;
				this.clientDetail.first_name = fd.first_name;
				this.clientDetail.first_name = fd.last_name;
				this.clientDetail.full_name = `${fd.first_name} ${fd.last_name ? fd.last_name : ''}`.trim();
				Swal.fire(i18n.done, i18n.client.client_name_updated, 'success');
				this.editNameMode = false;
				this.nameSubmitted = false;
			}, err => {
				this.loaderService.stopLoading();
				this.nameSubmitted = false;
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}

	deleteClient() {
		Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.client.you_want_to_delete_client,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText:
				i18n.yes,
			cancelButtonText:
				i18n.no_cancel_it
		}).then(result => {
			if (result.value) {
				this.loaderService.startLoading();
				this.clientService.delete(this.clientDetail.uuid).subscribe(r => {
					this.loaderService.stopLoading();

					Swal.fire(i18n.deleted, i18n.client.client_deleted, 'success');
					this.onDelete.emit(true);
				}, err => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				})
			}
		})
	}

	submit() {
		if (this.clientForm.valid) {
			this.loaderService.startLoading();
			this.clientService.update(this.clientForm.value).subscribe(data => {
				this.loaderService.stopLoading();

				Swal.fire(i18n.saved, i18n.client.client_updated, 'success');
				this.onSubmit.emit(true);
			}, err => {
				this.loaderService.stopLoading();

				// Set server side error
				if (err.status === 422) {
					if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;

						Object.keys(validationErrors).forEach((prop) => {
							this.clientForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}

				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			})
		}
	}

	toggleDropdown(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	downloadExcel() {
		const url = `${DashboardApi.download_excel}?section=client_edit&client_id=${this.clientDetail.id}&from_date=${this.from_date}&to_date=${this.to_date}`;
		window.open(url, '_blank');
	}

	downloadPDF() {
		const url = `${DashboardApi.download_pdf}?section=client_edit&client_id=${this.clientDetail.id}&from_date=${this.from_date}&to_date=${this.to_date}`;
		window.open(url, '_blank');
	}

	pdfInvoice(uuid: any) {
		(window as any).open(`${environment.baseUrl}/download-invoice/${uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
	}

	emailInvoices(selectedInvoices: Array<string>) {
		if (selectedInvoices.length) {
			this.loaderService.startLoading();

			this.invoiceService.action({ 'do': INVOICE_ACTIONS.EMAIL, 'ids': selectedInvoices }).subscribe(data => {
				this.loaderService.stopLoading();

				Swal.fire(i18n.done, i18n.email_sent, 'success');
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}

	whatsappInvoices(selectedInvoices: Array<string>) {
		if (selectedInvoices.length) {
			this.loaderService.startLoading();

			this.invoiceService.action({ 'do': INVOICE_ACTIONS.WHATSAPP, 'ids': selectedInvoices }).subscribe(data => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.done, i18n.invoice.whatsapp_message_sent, 'success');
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}

	deleteInvoices(selectedInvoices: Array<string>) {
		console.log(selectedInvoices);
		if (selectedInvoices.length) {
			Swal.fire({
				title: i18n.are_you_sure,
				text: i18n.invoice.you_want_to_delete_invoice,
				icon: 'info',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				confirmButtonText:
					i18n.yes,
				cancelButtonText:
					i18n.no_cancel_it
			}).then(result => {
				if (result.value) {

					this.loaderService.startLoading();

					this.invoiceService.action({ 'do': INVOICE_ACTIONS.DELETE, 'ids': selectedInvoices }).subscribe(data => {
						this.loaderService.stopLoading();

						Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');
						this.getProjects();
					}, err => {
						this.loaderService.stopLoading();
						Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					});
				}
			});
		}
	}

	orderActions(action, uuid) {
		switch (action) {
			case "edit_invoice":
				this.orderAction.emit({ uuid: uuid, action: action });
				break;
		}
	}


	get totalPages(): number {
		return Math.ceil(this.totalItems / this.itemsPerPage);
	}

	get paginationRange(): number[] {
		const range: number[] = [];

		const totalPages = this.totalPages;

		let start = Math.max(1, this.currentPage - Math.floor(this.maxPagesToShow / 2));
		let end = start + this.maxPagesToShow - 1;

		if (end > totalPages) {
			end = totalPages;
			start = Math.max(1, end - this.maxPagesToShow + 1);
		}

		for (let i = start; i <= end; i++) {
			range.push(i);
		}

		return range;
	}

	changePage(page: number) {
		if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
			this.currentPage = page;
			this.getProjects(page, true); // or your fetch function
		}
	}
	
	

}
